import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import Blockquote from "../../../../src/reusecore/Blockquote";
import image from "../../../../src/assets/images/layer5/layer5-only/svg/layer5-light-no-trim.svg";
import * as React from 'react';
export default {
  BlogWrapper,
  Blockquote,
  image,
  React
};